import { useEffect, useState } from 'react';

export const useCookieYes = () => {
  const [consent, setConsent] = useState<string | null>(null);

  const getConsentValue = () => {
    const cookieMatch = document.cookie
      .split('; ')
      .find((row) => row.startsWith('cookieyes-consent='));

    if (!cookieMatch) return null;

    const cookieValue = decodeURIComponent(cookieMatch.split('=')[1]);
    const consentObj = Object.fromEntries(cookieValue.split(',').map((item) => item.split(':')));

    return consentObj['consent'] || null;
  };

  useEffect(() => {
    if (consent === 'yes') return; // Stop checking if consent is already 'yes'

    const checkConsent = () => {
      const newConsent = getConsentValue();
      if (newConsent !== consent) {
        setConsent(newConsent);
      }
    };

    checkConsent(); // Initial check

    const interval = setInterval(checkConsent, 3000); // Poll every 3s

    return () => clearInterval(interval);
  }, [consent]);

  return consent;
};
